async function UpdateComponent(designcomponentid, designid, userid, itemnum, cfm, diameter, entryfactor, length, pressureloss, velocity, typeofpipe, junction, componentid, notes) {

    if (
        designid.length > 0 &&
        componentid.length > 0 &&
        userid.length > 0
    ) {

        let params = {
            "designComponentId": designcomponentid,
            "designId": designid,
            "userId": userid,
            "itemNum": itemnum,
            "cfm": cfm,
            "diameter": diameter,
            "entryFactor": entryfactor,
            "length": length,
            "pressureLoss": pressureloss,
            "velocity": velocity,
            "typeOfPipe": typeofpipe,
            "junction": junction,
            "componentId": componentid,
            "notes": notes
        };

        let response;

        response = await fetch("https://api.cssi.co/CNF/UpdateComponent", {
            method: "POST",
            body: JSON.stringify(params),

        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default UpdateComponent;